
import { defineComponent, PropType } from 'vue'
import { AxiosResponse } from 'axios'
import { iDocument, iMondrianSchema, iXMLATemplate, iMondrianTemplate } from '../../DocumentDetails'
import { mapState } from 'vuex'
import Dialog from 'primevue/dialog'
import descriptor from './DocumentDetailOlapDesignerDialogDescriptor.json'
import DocumentDetailXMLAForm from './DocumentDetailXMLAForm.vue'
import DocumentDetailMondrianForm from './DocumentDetailMondrianForm.vue'
import Dropdown from 'primevue/dropdown'
import ProgressSpinner from 'primevue/progressspinner'

const crypto = require('crypto')

export default defineComponent({
    name: 'document-detail-olap-designer-dialog',
    components: { Dialog, DocumentDetailXMLAForm, DocumentDetailMondrianForm, Dropdown, ProgressSpinner },
    props: { visible: { type: Boolean }, selectedDocument: { type: Object as PropType<iDocument> } },
    emits: ['designerStarted', 'close'],
    data() {
        return {
            descriptor,
            document: null as iDocument | null,
            mondrianSchemas: [] as iMondrianSchema[],
            type: 'mondrian' as string,
            xmlModel: { address: '', parameters: [] } as iXMLATemplate,
            mondrianModel: {} as iMondrianTemplate,
            sbiExecutionId: '',
            loading: false
        }
    },
    computed: {
        ...mapState({
            user: 'user'
        })
    },
    watch: {
        selectedDocument() {
            this.loadDocument()
        }
    },
    async created() {
        this.sbiExecutionId = crypto.randomBytes(16).toString('hex')
        this.loadDocument()
    },
    methods: {
        async loadDocument() {
            this.document = this.selectedDocument ? { ...this.selectedDocument } : ({} as iDocument)
            this.sbiExecutionId = crypto.randomBytes(16).toString('hex')

            this.initialize()
            this.loadMondrianSchemaResources()
        },
        async initialize() {
            if (!this.document || !this.user) return

            const language = this.user.locale?.split('_')[0]
            const uniqueID = this.user.userUniqueIdentifier
            const country = this.user.locale?.split('_')[1]

            const hiddenFormData = new URLSearchParams()
            hiddenFormData.set('document', decodeURIComponent('' + this.document.id))
            hiddenFormData.set('user_id', decodeURIComponent(uniqueID))
            hiddenFormData.set('DOCUMENT_LABEL', decodeURIComponent(this.document.label))
            hiddenFormData.set('SBI_COUNTRY', decodeURIComponent(country))
            hiddenFormData.set('DOCUMENT_AUTHOR', decodeURIComponent(this.document.creationUser))
            hiddenFormData.set('DOCUMENT_DESCRIPTION', decodeURIComponent(this.document.description))
            hiddenFormData.set('SBI_LANGUAGE', decodeURIComponent(language))
            hiddenFormData.set('DOCUMENT_NAME', decodeURIComponent(this.document.name))
            hiddenFormData.set('NEW_SESSION', decodeURIComponent('TRUE'))
            hiddenFormData.set('SBI_EXECUTION_ID', decodeURIComponent(this.sbiExecutionId))
            hiddenFormData.set('EDIT_MODE', decodeURIComponent('null'))
            hiddenFormData.set('timereloadurl', decodeURIComponent('' + new Date().getTime()))
            hiddenFormData.set('ENGINE', 'knowageolapengine')

            this.$store.commit('setLoading', true)
            await this.$http.post(process.env.VUE_APP_OLAP_PATH + `olap/startolap/edit`, hiddenFormData, { headers: { Accept: 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9' } }).then(() => {})
            this.$store.commit('setLoading', false)
        },
        async loadMondrianSchemaResources() {
            this.$store.commit('setLoading', true)
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `2.0/mondrianSchemasResource`).then((response: AxiosResponse<any>) => (this.mondrianSchemas = response.data))
            this.$store.commit('setLoading', false)
        },
        closeDialog() {
            this.$emit('close')
            this.type = 'xmla'
            this.xmlModel = { address: '', parameters: [] }
            this.mondrianModel = {} as iMondrianTemplate
        },
        async start() {
            const postData = this.type === 'xmla' ? { ...this.xmlModel } : { ...this.mondrianModel }
            this.$store.commit('setLoading', true)
            await this.$http
                .post(process.env.VUE_APP_OLAP_PATH + `1.0/designer/cubes?SBI_EXECUTION_ID=${this.sbiExecutionId}`, postData, { headers: { Accept: 'application/json, text/plain, */*' } })
                .then(() => {
                    this.$emit('designerStarted', { ...this.selectedDocument, sbiExecutionId: this.sbiExecutionId, reference: this.mondrianModel?.mondrianSchema, artifactId: this.mondrianModel.mondrianSchemaId })
                })
                .catch(() => {})
            this.$store.commit('setLoading', false)
        }
    }
})
